// src/components/Layout/Header.tsx
import React from "react";
import { useAuth } from "../../contexts/AuthContext";

const Header: React.FC = () => {
  const { currentUser, userData } = useAuth();

  return (
    <header className="sticky top-0 z-40 bg-white border-b border-gray-200 shadow-sm">
      <div className="flex items-center justify-end h-16 px-6">
        {/* User Profile */}
        <div className="flex items-center space-x-4">
          <div className="hidden md:block text-right">
            <p className="text-sm font-medium text-gray-900">
              {userData?.name || "Admin"}
            </p>
            <p className="text-xs text-gray-500">
              {userData?.email || "Admin"}
            </p>
          </div>
          <div className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center">
            <span className="text-sm font-semibold text-amber-500">
              {(userData?.name || currentUser?.email || "A")
                .charAt(0)
                .toUpperCase()}
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
